













import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { CourseAspect } from '@/app/shared/models';
import { handleBeforePageRouteEnter } from '@/app/shared/utils/route-utils';
import aspectStoreModule from '@/app/aspect/apsect-state';
import SidebarNavigationComponent from '@/app/sidebar-navigation/components/sidebar-navigation-component.vue';

@Component({
  components: {
    SidebarNavigationComponent
  },
  beforeRouteEnter: async (to: Route, from: Route, next: any): Promise<void> => {
    await handleBeforePageRouteEnter(to, next);
  }
})
export default class CourseLayoutComponent extends Vue {
  public get courseAspect(): CourseAspect|null {
    return aspectStoreModule.selectedCourseAspectInstance;
  }

  public get backgroundImageUri(): string {
    let uri: string = '';
    const theme = process.env.VUE_APP_THEME_NAME
    if (aspectStoreModule.selectedChapter !== null && aspectStoreModule.selectedChapter.backgroundUri) {
      uri = aspectStoreModule.selectedChapter.backgroundUri;
    } else if (aspectStoreModule.selectedCourseAspectInstance !== null
      && aspectStoreModule.selectedCourseAspectInstance.sectionBackgroundUri !== null) {
      uri = aspectStoreModule.selectedCourseAspectInstance.sectionBackgroundUri;
    } else {
      uri = require('@/assets/images/'+theme+'/background-2.png');
    }

    return uri;
  }
}
